const analysisGridlets = angular.module('analysisGridletDirectives', []);

analysisGridlets.directive('alarmAnalysisGridletModule', function(
  analysisService,
  $translate,
  $timeout,
  eventService,
  toasterService,
  chartColorService,
  historyExportService,
  $log
) {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/gridlets/analysis/alarm-analysis-gridlet-module.html',
    scope: {
      settings: '=',
      view: '=',
      fullscreen: '=',
    },
    controller: [
      '$scope',
      function($scope) {
        $scope.$log = $log;
        $scope.optionsMenu = {
          startDateOpened: false,
          endDateOpened: false,
          openStartDatePicker: function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.optionsMenu.startDateOpened = true;
            $scope.optionsMenu.endDateOpened = false;
          },
          openEndDatePicker: function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.optionsMenu.startDateOpened = false;
            $scope.optionsMenu.endDateOpened = true;
          },
          datePickerFormat: 'dd.MM.yyyy',
          dateOptions: {
            startingDay: 1,
            showWeeks: false,
          },
        };
      },
    ],
    link: function(scope) {
      let previousLoadWasHeatmap;

      function loadEmuList() {
        analysisService.emuList().then(function(data) {
          if (!angular.equals(scope.emuList, data)) {
            scope.emuList = [];
            _.each(data, function(emu) {
              scope.emuList.push({ title: emu, value: emu, selected: false });
            });
          }
        });
      }

      function loadSubsystemInfo() {
        analysisService.subsystemInfo().then(function(data) {
          if (!angular.equals(scope.subsystemInfo, data)) {
            scope.subsystemInfo = [];
            _.each(data, function(subsystem) {
              scope.subsystemInfo.push({
                value: subsystem.id,
                title: subsystem.name,
                items: subsystem.items,
              });
            });
          }
        });
      }

      function loadEventInfo() {
        analysisService.eventInfo().then(function(data) {
          if (!angular.equals(scope.eventInfo, data)) {
            scope.eventInfo = [];
            _.each(data, function(event) {
              scope.eventInfo.push({
                title: event.name,
                value: event.id,
                subsystem: event.subsystemName,
                subsystemId: event.subsystemId,
              });
            });
          }
          scope.eventInfoFiltered = angular.copy(scope.eventInfo);
        });
      }

      scope.$watchCollection('selection', function() {
        if (!scope.oldHeatMapEndDate && !scope.oldHeatMapStartDate) {
          loadGraphData();
        }
      });
      scope.$watchCollection('selection.subsystems', function() {
        createFilteredEventInfo();
      });
      scope.$watchCollection('selection.chartTypeConfig.selectors', function(newVal) {
        const selectors = ['emus', 'subsystems', 'events', 'chartType'];
        const notIncluded = _.difference(selectors, newVal);
        _.each(notIncluded, function(value) {
          scope.resetSelection(value);
        });
      });
      scope.$watch('config.series', function() {
        scope.showData =
          (typeof scope.config.series[0] !== 'undefined' && scope.config.series[0].data.length > 0) ||
          (typeof scope.config.series.data !== 'undefined' && scope.config.series.data.length > 0);
      });
      function createFilteredEventInfo() {
        scope.eventInfoFiltered = [];
        const subsystems = angular.copy(scope.selection.subsystems);
        if (subsystems.length === 0 || subsystems[0].value === 'ALL') {
          scope.eventInfoFiltered = angular.copy(scope.eventInfo);
        } else {
          const ids = {};
          _.each(subsystems, function(id) {
            ids[id.value] = true;
          });
          scope.eventInfoFiltered = _.filter(scope.eventInfo, function(event) {
            return ids[event.subsystemId];
          });
          const lengthBefore = scope.selection.events.length;
          if (lengthBefore > 0) {
            scope.selection.events = _.filter(scope.selection.events, function(event) {
              return ids[event.subsystemId];
            });
          }
          const lengthAfter = scope.selection.events.length;
          if (lengthBefore > lengthAfter) {
            toasterService.warningWithTimeout(
              $translate.instant('toaster.subsystem-filter-event-removal-title'),
              $translate.instant('toaster.subsystem-filter-event-removal'),
              5000
            );
          }
        }
      }
      scope.resetAll = function() {
        scope.selection.emus = [];
        scope.selection.subsystems = [];
        scope.selection.events = [];
        scope.selection.active = null;
        scope.selection.startDate = null;
        scope.selection.endDate = null;
      };
      scope.resetAllFilters = function() {
        scope.selection.emus = [];
        scope.selection.subsystems = [];
        scope.selection.events = [];
      };
      scope.resetSelection = function(selector) {
        switch (selector) {
          case 'emus':
            scope.selection.emus = [];
            break;
          case 'subsystems':
            scope.selection.subsystems = [];
            break;
          case 'events':
            scope.selection.events = [];
            break;
        }
      };
      scope.showChartType = function(chartType) {
        const show = scope.selection.chartTypeConfig.chartTypes.includes(chartType);
        if (!show && chartType === scope.config.chart.type) {
          scope.config.chart.type = angular.copy(scope.selection.chartTypeConfig.chartTypes[0]);
        }
        return show;
      };
      scope.showSelector = function(selector) {
        return scope.selection.chartTypeConfig.selectors.includes(selector);
      };
      function getParams() {
        const params = {
          startDate: null,
          endDate: null,
          emus: [],
          subsystemIds: [],
          eventIds: [],
          active: null,
          skip: null,
          count: 15,
          sortType: scope.sortType,
          reversed: scope.reversed,
          export: null,
        };
        if (scope.selection.startDate) {
          params.startDate = DateTime.fromJSDate(scope.selection.startDate).toFormat('yyyy-MM-dd');
        }
        if (scope.selection.endDate) {
          params.endDate = DateTime.fromJSDate(scope.selection.endDate)
            .plus({days: 1})
            .toFormat('yyyy-MM-dd');
        }
        if (checkArray(scope.selection.emus)) {
          _.each(scope.selection.emus, function(emu) {
            params.emus.push(emu.value);
          });
        }
        if (checkArray(scope.selection.subsystems)) {
          _.each(scope.selection.subsystems, function(subsystem) {
            params.subsystemIds.push(subsystem.value);
          });
        }
        if (checkArray(scope.selection.events)) {
          _.each(scope.selection.events, function(event) {
            params.eventIds.push(event.value);
          });
        }
        if (scope.selection.active !== null) {
          params.active = scope.selection.active;
        }
        return params;
      }

      function checkArray(array) {
        return typeof array !== 'undefined' && array !== null && array.length > 0;
      }

      function loadGraphData(event) {
        if (!scope.analysisConnection || !scope.initialized) {
          return;
        }
        if (scope.selection.chartTypeConfig.type === 'table') {
          scope.chartLoading = false;
          scope.chartPresentation = false;
          scope[scope.selection.chartTypeConfig.dataLoad](true);
        } else {
          scope.chartLoading = true;
          scope.chartPresentation = true;
          if (previousLoadWasHeatmap && scope.selection.chartTypeConfig.value !== 'faultHeatMap') {
            chartConfigDefaults();
            previousLoadWasHeatmap = false;
          }
          if (
            event &&
            scope.selection.chartTypeConfig.clickLoad &&
            scope.selection.chartTypeConfig.clickLoad.length > 0
          ) {
            scope[scope.selection.chartTypeConfig.clickLoad](event);
          } else {
            scope[scope.selection.chartTypeConfig.dataLoad]();
          }
        }
      }

      //heatmapclickLoad is a different beast
      function loadHeatClick(event) {
        scope.chartLoading = true;
        scope.selection.emus.push({
          value: scope.config.xAxis.categories[event.x],
        });
        scope.selection.startDate = scope.config.yAxis.categories[event.y];
        scope.selection.endDate = scope.config.yAxis.categories[event.y];
        chartConfigDefaults();
        previousLoadWasHeatmap = false;
        scope[scope.selection.chartTypeConfig.clickLoad]();
        setSelectionRight();
      }

      scope.loadGroupsById = function(event) {
        if (!scope.analysisConnection || !scope.initialized) {
          return;
        }
        const params = getParams();
        if (event) {
          params.emus = [];
          params.emus.push(event.name);
        }
        analysisService.groupsById(params).then(function(data) {
          chartColorService.fillDataWithColors(data);
          if (!angular.equals(scope.config.series, data)) {
            scope.config.series = data;
            if (event) {
              scope.selection.emus.push({ value: event.name });
              setSelectionRight();
            }
            scope.totalEvents = data[0].count;
            scope.$broadcast('reflow');
          }
          scope.chartLoading = false;
        });
      };
      scope.loadEventsByGroup = function(event) {
        if (!scope.analysisConnection || !scope.initialized) {
          return;
        }
        const params = getParams();
        if (event) {
          params.subsystemsIds = [];
          params.subsystemsIds.push(event.drillId);
        }
        analysisService.eventsByGroup(params).then(function(data) {
          chartColorService.fillDataWithColors(data);
          if (!angular.equals(scope.config.series, data)) {
            scope.config.series = data;
            if (event) {
              scope.selection.subsystems = [];
              scope.selection.subsystems.push({ value: event.drillId });
              setSelectionRight();
            }
            scope.totalEvents = data[0].count;
            scope.$broadcast('reflow');
          }
          scope.chartLoading = false;
        });
      };
      scope.loadEventsStacked = function(event) {
        if (!scope.analysisConnection || !scope.initialized) {
          return;
        }
        const params = getParams();
        if (event) {
          params.eventIds = [];
          params.eventIds.push(event.drillId);
        }
        analysisService.eventsStacked(params).then(function(data) {
          chartColorService.fillDataWithColors(data);
          if (!angular.equals(scope.config.series, data)) {
            scope.config.series = data;
            if (event) {
              scope.selection.events.push({ value: event.drillId });
              setSelectionRight();
            }
            scope.totalEvents = data[0].count;
            scope.$broadcast('reflow');
          }
          scope.chartLoading = false;
        });
      };

      scope.loadGroupsStacked = function() {
        if (!scope.analysisConnection || !scope.initialized) {
          return;
        }
        const params = getParams();
        analysisService.groupsStacked(params).then(function(data) {
          chartColorService.fillDataWithColors(data);
          if (!angular.equals(scope.config.series, data)) {
            scope.config.series = data;
            scope.$broadcast('reflow');
          }
          scope.totalEvents = data[0].count;
          scope.chartLoading = false;
        });
      };

      scope.loadFaultHeatMap = function() {
        if (!scope.analysisConnection || !scope.initialized) {
          return;
        }
        const params = getParams();

        analysisService.eventHeatMap(params).then(function(data) {
          if (!angular.equals(scope.config.series, data.data)) {
            createHeatMapConfig(data);
            if (scope.oldHeatMapStartDate && scope.oldHeatMapStartDate === scope.config.yAxis.categories[0]) {
              toasterService.warningWithTimeout(
                $translate.instant('toaster.heatmap-warning-title'),
                $translate.instant(
                  'toaster.heatmap-warning-before-text',
                  {
                    value: DateTime.fromISO(scope.config.yAxis.categories[0]).toFormat('dd.MM.yyyy'),
                  },
                  5000
                )
              );
            } else if (
              scope.oldHeatMapEndDate &&
              scope.oldHeatMapEndDate === scope.config.yAxis.categories.slice(-1)[0]
            ) {
              toasterService.warningWithTimeout(
                $translate.instant('toaster.heatmap-warning-title'),
                $translate.instant('toaster.heatmap-warning-after-text', {
                  value: DateTime.fromISO(scope.config.yAxis.categories.slice(-1)[0]).toFormat('dd.MM.yyyy'),
                }),
                5000
              );
            }
            scope.selection.startDate = scope.config.yAxis.categories[0];
            scope.selection.endDate = scope.config.yAxis.categories.slice(-1)[0];
            scope.totalEvents = data.count;
            scope.$broadcast('reflow');
          }
          scope.oldHeatMapStartDate = null;
          scope.oldHeatMapEndDate = null;
          previousLoadWasHeatmap = true;
          scope.chartLoading = false;
        });
      };

      // EVENT HISTORY
      scope.loadEventHistoryData = function(reload, sortType, reversed) {
        if (!scope.analysisConnection || !scope.initialized) {
          return;
        }
        scope.chartLoading = true;
        scope.loadBusy = true;
        scope.showData = false;
        scope.chartLoading = false;
        scope.chartPresentation = false;

        const params = getParams();

        if (!!reload) {
          params.skip = 0;
        } else {
          params.skip = scope.eventHistory.length;
        }

        params.sortType = sortType ? sortType.toUpperCase() : null;
        params.reversed = reversed || false;

        analysisService.eventHistory(params).then(function(data) {
          if (data !== null) {
            if (!angular.equals(scope.eventHistory, data)) {
              if (reload) {
                scope.eventHistory = data;
              } else {
                scope.eventHistory = scope.eventHistory.concat(data);
              }
              // If success, copy to scope
              scope.sortType = params.sortType;
              scope.reversed = params.reversed;
            }
          }
        });
        scope.loadBusy = false;
        scope.chartLoading = false;
      };

      scope.exportToExcel = function() {
        historyExportService.exportToExcel(getParams());
      };

      scope.exportToCsv = function() {
        historyExportService.exportToCsv(getParams());
      };

      scope.$watch('selection.chartTypeConfig.type', function(type) {
        scope.$emit('gridlet-register-export', type === 'table' ? {
          excel: scope.exportToExcel,
          csv: scope.exportToCsv,
        } : null);
      });

      function setSelectionRight() {
        scope.selection.chartTypeConfig = angular.copy(
          scope.chartConfigList.find(v => v.value === scope.selection.chartTypeConfig.clickValue)
        );
      }

      //chart partition controls
      scope.$on('gridlet-init', function() {
        scope.$broadcast('reflow');
      });
      scope.$on('gridlet-refresh', function() {
        scope.$broadcast('reflow');
      });
      scope.selectChartType = function(chartType) {
        scope.config.chart.type = chartType;
      };
      scope.nextTenDays = function() {
        scope.oldHeatMapEndDate = angular.copy(scope.selection.endDate);
        scope.selection.startDate = angular.copy(scope.config.yAxis.categories.slice(-1)[0]);
        scope.selection.endDate = null;
        loadGraphData();
      };
      scope.previousTenDays = function() {
        scope.oldHeatMapStartDate = angular.copy(scope.selection.startDate);
        scope.selection.endDate = angular.copy(scope.config.yAxis.categories[0]);
        scope.selection.startDate = null;
        loadGraphData();
      };
      function createHeatMapConfig(data) {
        scope.config = {
          series: [
            {
              name: 'Faults',
              borderWidth: 1,
              data: data.data,
              dataLabels: {
                enabled: true,
                color: '#000000',
              },
            },
          ],
          xAxis: {
            categories: data.xAxis,
          },
          yAxis: {
            categories: data.yAxis,
            title: null,
            allowDecimals: false,
          },
          colorAxis: {
            min: 0,
            minColor: '#FFFFFF',
            maxColor: '#337ab7',
          },
          legend: {
            align: 'right',
            layout: 'vertical',
            margin: 0,
            verticalAlign: 'top',
            y: 25,
            symbolHeight: 280,
          },
          tooltip: {
            formatter: function() {
              return (
                '<b>' +
                this.point.value +
                '</b> Faults on <br><b>' +
                this.series.xAxis.categories[this.point.x] +
                '</b> on <br><b>' +
                DateTime.fromISO(this.series.yAxis.categories[this.point.y]).toFormat('dd.MM.yyyy') +
                '</b>'
              );
            },
          },
          chart: {
            type: 'heatmap',
            marginTop: 40,
            marginBottom: 80,
            plotBorderWidth: 1,
          },
          plotOptions: {
            series: {
              cursor: 'pointer',
              point: {
                events: {
                  click: function(e) {
                    loadHeatClick(angular.copy(e.point));
                  },
                },
              },
            },
          },
        };
        previousLoadWasHeatmap = true;
      }

      function chartConfigDefaults() {
        scope.config = {
          chart: {
            type: 'column',
          },
          xAxis: {
            type: 'category',
          },
          yAxis: {
            allowDecimals: false,
          },
          legend: {},
          tooltip: {
            formatter: function() {
              if (scope.config.chart.type === 'column') {
                let tip = '<b>' + this.key;
                const stackSelected = this.point.series.options.stack;
                const categorySelected = this.point.category;
                tip += '<br/><br/>';

                $.each(this.series.chart.series, function(i, s) {
                  if (s.options.stack === stackSelected) {
                    $.each(s.data, function(j, point) {
                      if (point.category === categorySelected && point.y > 0)
                        tip +=
                          '<span style="color:' +
                          point.series.color +
                          '">\u25CF</span> ' +
                          s.name +
                          ': ' +
                          point.y +
                          '<br>';
                    });
                  }
                });
                return tip;
              } else {
                return '<span style="color:' + this.color + '">\u25CF</span> <b> ' + this.key + ': </b>' + this.y;
              }
            },
            shared: false,
          },
          plotOptions: {
            column: {
              stacking: 'normal',
            },
            series: {
              cursor: 'pointer',
              point: {
                events: {
                  click: function(e) {
                    loadGraphData(angular.copy(e.point));
                  },
                },
              },
            },
          },
          series: [],
        };
        scope.$broadcast('reload');
      }

      eventService.on('analysis-offline', function() {
        scope.analysisConnection = false;
        offlinePoller();
      });

      function offlinePoller() {
        $timeout.cancel(scope.timeoutPromise);
        scope.timeoutPromise = $timeout(function() {
          scope.analysisConnection = true;
          loadGraphData();
        }, 10000);
      }

      scope.chartConfigList = [
        {
          value: 'groupsById',
          title: $translate.instant('analysis.alarm-analysis-gridlet-module.chart-selections.groups-by-id'),
          chartTypes: ['pie', 'column'],
          selectors: ['chartType', 'emus', 'subsystems'],
          dataLoad: 'loadGroupsById',
          clickValue: 'eventsByGroup',
          clickLoad: 'loadEventsByGroup',
          clickInfo: $translate.instant(
            'analysis.alarm-analysis-gridlet-module.chart-selections.groups-by-id-click-info'
          ),
          type: 'chart',
        },
        {
          value: 'eventsByGroup',
          title: $translate.instant('analysis.alarm-analysis-gridlet-module.chart-selections.events-by-group'),
          chartTypes: ['pie', 'column'],
          selectors: ['chartType', 'emus', 'subsystems', 'events'],
          dataLoad: 'loadEventsByGroup',
          clickValue: 'eventsStacked',
          clickLoad: 'loadEventsStacked',
          clickInfo: $translate.instant(
            'analysis.alarm-analysis-gridlet-module.chart-selections.events-by-group-click-info'
          ),
          type: 'chart',
        },
        {
          value: 'eventsStacked',
          title: $translate.instant('analysis.alarm-analysis-gridlet-module.chart-selections.events-stacked'),
          chartTypes: ['column'],
          selectors: ['chartType', 'emus', 'subsystems', 'events'],
          dataLoad: 'loadEventsStacked',
          clickValue: 'groupsById',
          clickLoad: 'loadGroupsById',
          clickInfo: $translate.instant(
            'analysis.alarm-analysis-gridlet-module.chart-selections.events-stacked-click-info'
          ),
          type: 'chart',
        },
        {
          value: 'groupsStacked',
          title: $translate.instant('analysis.alarm-analysis-gridlet-module.chart-selections.groups-stacked'),
          chartTypes: ['column'],
          selectors: ['chartType', 'emus', 'subsystems'],
          dataLoad: 'loadGroupsStacked',
          clickValue: 'groupsById',
          clickLoad: 'loadGroupsById',
          clickInfo: $translate.instant(
            'analysis.alarm-analysis-gridlet-module.chart-selections.groups-stacked-click-info'
          ),
          type: 'chart',
        },
        {
          value: 'faultHeatMap',
          title: $translate.instant('analysis.alarm-analysis-gridlet-module.chart-selections.event-heat-map'),
          chartTypes: ['heatmap'],
          selectors: ['chartType', 'emus', 'subsystems', 'events'],
          dataLoad: 'loadFaultHeatMap',
          clickValue: 'eventsByGroup',
          clickLoad: 'loadEventsByGroup',
          clickInfo: $translate.instant(
            'analysis.alarm-analysis-gridlet-module.chart-selections.event-heat-map-click-info'
          ),
          type: 'chart',
        },
        {
          value: 'eventHistoryData',
          title: $translate.instant('analysis.alarm-analysis-gridlet-module.chart-selections.event-history-data'),
          chartTypes: ['table'],
          selectors: ['chartType', 'emus', 'subsystems', 'events'],
          dataLoad: 'loadEventHistoryData',
          clickValue: '',
          clickLoad: '',
          clickInfo: '',
          type: 'table',
        },
      ];

      scope.$on('$destroy', function() {
        $timeout.cancel(scope.timeoutPromise);
        scope.analysisConnection = true;
      });

      scope.selection = {
        startDate: null,
        endDate: null,
        events: [],
        subsystems: [],
        emus: [],
        chartTypeConfig: scope.chartConfigList[0],
        active: null,
      };

      previousLoadWasHeatmap = false;

      function init() {
        scope.initialized = false;
        scope.emuList = [{ title: 'ALL', value: 'ALL' }];
        scope.subsystemInfo = [];
        scope.eventInfo = [];
        scope.eventInfoFiltered = [];
        scope.totalEvents = 0;
        scope.oldHeatMapEndDate = null;
        scope.oldHeatMapStartDate = null;
        scope.chartLoading = false;
        scope.analysisConnection = true;
        scope.chartPresentation = true;
        scope.eventHistory = [];
        scope.eventsLoading = false;
        scope.loadBusy = false;
        scope.sortType = null;
        scope.reversed = false;
        loadEmuList();
        loadSubsystemInfo();
        loadEventInfo();
        chartConfigDefaults();
        $timeout(function() {
          scope.initialized = true;
          loadGraphData();
        }, 500);
      }

      init();
    },
  };
});

analysisGridlets.directive('eventHistory', function($log, $filter) {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/gridlets/analysis/alarm-analysis-event-history.html',
    scope: {
      eventHistory: '=',
      loadBusy: '=',
      loadMore: '&',
    },
    link: function(scope) {
      scope.$watch(
        'loadBusy',
        function(newVal) {
          //console.log(newVal)
        },
        true
      );
      scope.toggleOverflow = function(index) {
        scope.overflow[index] = scope.overflow[index] ? '' : 'showOverflow';
      };
      scope.sortColumn = function(sortType) {
        scope.sortType = sortType || null;
        scope.reversed[sortType] = !scope.reversed[sortType];
        scope.loadMore({
          reload: true,
          sortType: scope.sortType,
          reversed: scope.reversed[sortType],
        });
      };
      scope.formatDate = function(datetime) {
        if (datetime === null) return '';
        return $filter('date')(new Date(datetime), 'dd.MM.yyyy HH:mm:ss');
      };
      scope.$watch('eventHistory', function() {
        scope.overflow = {};
      });
      const init = function () {
        scope.hidden = [];
        scope.overflow = {};
        scope.sortType = null;
        scope.reversed = {
          train: true,
          car: true,
          event_id: true,
          emu: true,
          activated: false,
          deactivated: false,
          name: true,
          occ_acknowledged: false,
          occ_ack_user: true,
          moc_acknowledged: false,
          moc_ack_user: true,
        };
      };
      init();
    },
  };
});
